module.exports = __webpack_public_path__ + "expand_icon.ed9a069cd19fee4bd44b1885f621fc2e.svg";